import React, { Fragment, useEffect, useState } from 'react';
import { object, func } from 'prop-types';
import { connect } from 'react-redux';
import { Form, Icon } from 'antd';
import * as R from 'ramda';

import { SelectDropdown } from '../../components/request-form/styles';
import { handleRequestUpdateModal } from '../../redux/thunk/requests';
import { getItemById, debounce, formatTalentsData } from '../../utils';
import Talent from '../../components/talents-list/talent';
import { OptionPopover } from './talent-info-popover';
import { fetchTalents } from '../../api/apiko-api';
import { closeCurrentModal } from '../../modals';
import { debounceTime } from '../constants';
import {
  Title,
  SubTitle,
  SelectS,
  FormItem,
  ButtonSave,
  FieldWrapper,
  StyledOption,
  ButtonWrapper,
  HistoryWrapper,
} from './styled-components';

const debouncedFetch = debounce(fetchTalents, debounceTime);

const Component = ({
  form: { getFieldDecorator },
  request,
  closeModal,
  updateRequestAction,
}) => {
  const defaultTalents = request.talents
    ? formatTalentsData(request.talents)
    : [];
  const defaultTalentsIds = defaultTalents.map(({ _id }) => _id);

  const [searchTerm, setSearchTerm] = useState('');
  const [searchedTalents, setData] = useState(defaultTalents);
  const [selectedTalents, setSelectedTalents] = useState(defaultTalents);
  const [isFetchingTalents, setIsFetchingTalents] = useState(false);

  useEffect(() => {
    if (searchTerm.length > 1) {
      setIsFetchingTalents(true);
      debouncedFetch({ searchTerm })
        .then((res) => {
          setData(formatTalentsData(res));
          setIsFetchingTalents(false);
        });
    } else setData([]);
  }, [searchTerm]);

  const handleSelectTalents = (ids) => {
    const selectedTalentsData =
      [...defaultTalents, ...searchedTalents, ...selectedTalents].reduce((acc, item) => {
        if (ids.includes(item._id) && !acc[item._id]) {
          acc[item._id] = item;
        }

        return acc;
      }, {});

    setSelectedTalents(Object.values(selectedTalentsData));
  };

  const submitFormHandler = (e) => {
    e.preventDefault();
    const data = new FormData();

    if (!R.equals(defaultTalents, selectedTalents)) {
      const ids = selectedTalents.map(({ _id }) => _id);
      data.append('talents', JSON.stringify(ids));
    }

    closeModal();
    return updateRequestAction(request._id, data);
  };

  return (
    <Fragment>
      <Title>Manage Talents</Title>
      <SubTitle>You can assign / unassign talents here</SubTitle>
      <Form onSubmit={submitFormHandler}>
        <FieldWrapper>
          <FormItem
            colon={false}
            label="Talents"
          >
            <div onMouseDown={(e) => {
              e.preventDefault();
              return false;
            }}
            >
              {getFieldDecorator('talents', {
                initialValue: defaultTalentsIds,
              })(<SelectS
                autoFocus
                showSearch
                allowClear
                size="large"
                mode="multiple"
                showArrow={false}
                filterOption={false}
                loading={isFetchingTalents}
                onSearch={setSearchTerm}
                onChange={handleSelectTalents}
                defaultActiveFirstOption={false}
                placeholder="Search talents by full name..."
                notFoundContent={isFetchingTalents ? null : 'Not Found...'}
                getPopupContainer={triggerNode => triggerNode.parentNode}
                dropdownRender={(menu) => {
                  if (!isFetchingTalents && menu.props.inputValue.length > 1) {
                    return (
                      <SelectDropdown>
                        {menu}
                      </SelectDropdown>
                    );
                  }
                  return (<SelectDropdown />);
                }}
              >
                {searchedTalents.map(item => (
                  <StyledOption key={item._id} value={item._id}>
                    {item.enFullName}

                    <OptionPopover talent={item}>
                      <Icon
                        type="info-circle"
                        style={{ paddingLeft: '10px', cursor: 'pointer' }}
                      />
                    </OptionPopover>
                  </StyledOption>
                ))}
              </SelectS>)}
            </div>
          </FormItem>

        </FieldWrapper>

        {!R.equals(defaultTalents, selectedTalents) && (
          <Fragment>
            {R.difference(defaultTalents, selectedTalents).length > 0 && (
              <HistoryWrapper
                showBottomBorder={
                  R.difference(selectedTalents, defaultTalents).length > 0
                }
              >
                <div>Removed talents:</div>
                {R.difference(defaultTalents, selectedTalents)
                  .map((talent, index) => (
                    <Talent
                      {...talent}
                      key={talent._id}
                      number={index + 1}
                      requestId={request._id}
                      withoutAdditionalActions
                    />))}
              </HistoryWrapper>
            )}
            {R.difference(selectedTalents, defaultTalents).length > 0 && (
              <HistoryWrapper>
                <div>Added talents:</div>
                {R.difference(selectedTalents, defaultTalents)
                  .map((talent, index) => (
                    <Talent
                      {...talent}
                      key={talent._id}
                      number={index + 1}
                      requestId={request._id}
                      withoutAdditionalActions
                    />))}
              </HistoryWrapper>
            )}
          </Fragment>
        )}

        <ButtonWrapper>
          <ButtonSave key="submit" type="primary" htmlType="submit">
            Save
          </ButtonSave>
        </ButtonWrapper>
      </Form>
    </Fragment>
  );
};

Component.propTypes = {
  form: object.isRequired,
  request: object.isRequired,
  closeModal: func.isRequired,
  updateRequestAction: func.isRequired,
};


const mapStateToProps = ({ requests }, { payload }) => ({
  request: getItemById(payload.requestId, requests),
});

const mapDispatchToProps = dispatch => ({
  updateRequestAction: (requestId, modifier) =>
    dispatch(handleRequestUpdateModal(requestId, modifier)),
  closeModal: () => dispatch(closeCurrentModal()),
});

const component = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Component);

export const ManageTalentsModal = Form.create()(component);



// WEBPACK FOOTER //
// ./src/modals/manage-talents-modal/index.js